document.documentElement.classList.remove('no-js');
const toggle = document.querySelector('.menu-toggle');
const mobileMenu = document.querySelector('#MobileMenu');
if (toggle && mobileMenu) {
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
  });
}

// Set the actual dates for the next Saturday and Sunday in the bakery's timezone.
const weekendSelect = document.querySelector('[data-weekend-date]');
if (weekendSelect) {
  const dateParts = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
  const dateValue = type => Number(dateParts.find(part => part.type === type).value);
  const year = dateValue('year'), month = dateValue('month'), day = dateValue('day');
  const today = new Date(Date.UTC(year, month - 1, day));
  const weekday = today.getUTCDay();
  const saturday = new Date(today);
  saturday.setUTCDate(today.getUTCDate() + ((6 - weekday + 7) % 7));
  const sunday = new Date(saturday);
  sunday.setUTCDate(saturday.getUTCDate() + 1);
  const format = date => date.toISOString().slice(0, 10);
  const display = date => new Intl.DateTimeFormat('en-US', {timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric'}).format(date);
  const saved = weekendSelect.dataset.saved;
  weekendSelect.options[1].value = format(saturday);
  weekendSelect.options[1].textContent = display(saturday);
  weekendSelect.options[2].value = format(sunday);
  weekendSelect.options[2].textContent = display(sunday);
  if (saved === format(saturday)) weekendSelect.selectedIndex = 1;
  if (saved === format(sunday)) weekendSelect.selectedIndex = 2;
}

const customCakeDate = document.querySelector('[data-custom-cake-date]');
if (customCakeDate) {
  const parts = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
  const value = type => Number(parts.find(part => part.type === type).value);
  const earliest = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + 10));
  customCakeDate.min = earliest.toISOString().slice(0, 10);
}
